import { render } from "./TheGameMenu.vue?vue&type=template&id=683d0621"
import script from "./TheGameMenu.vue?vue&type=script&lang=js"
export * from "./TheGameMenu.vue?vue&type=script&lang=js"
script.render = render

export default script